import React from "react";
import { Button } from "antd";
import "./index.scss";

export type CardLayoutProps = {
  title: string;
  children: React.ReactNode;
  className?: string;
};

function CardLayout({ title, children, className = "" }: CardLayoutProps) {
  return (
    <div className={`card-layout ${className}`}>
      <div className="card-layout-header">
        <h2 className="card-layout-title">{title}</h2>
      </div>
      <div className="card-layout-content">{children}</div>
    </div>
  );
}

export type SmallCardProps = {
  title: string | React.ReactNode;
  description: string | React.ReactNode;
  buttonText: string;
  icon?: React.ReactNode;
  onButtonClick?: () => void;
  className?: string;
};

function SmallCard({
  title,
  description,
  buttonText,
  icon,
  onButtonClick,
  className = "",
}: SmallCardProps) {
  return (
    <div className={`small-card ${className}`}>
      {icon && <div className="small-card-icon">{icon}</div>}
      <h3 className="small-card-title">{title}</h3>
      <div className="small-card-description">{description}</div>
      <Button
        type="primary"
        className="small-card-button"
        onClick={onButtonClick}
      >
        {buttonText}
      </Button>
    </div>
  );
}

export type CardGroupProps = {
  title: string;
  children: React.ReactNode;
  className?: string;
  titleActions?: React.ReactNode;
};

function CardGroup({
  title,
  children,
  className = "",
  titleActions,
}: CardGroupProps) {
  const titleWithActions = titleActions ? (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <span>{title}</span>
      {titleActions}
    </div>
  ) : (
    title
  );

  return (
    <CardLayout title={titleWithActions} className={className}>
      <div className="card-group-container">{children}</div>
    </CardLayout>
  );
}

export { CardLayout, SmallCard, CardGroup };
